import { ApiStatus } from "./api.types";

/**
 * Entity types a tag can be scoped to via the master's `appliesTo` array.
 * These strings are stored as-is on the Tag document, so they must stay in
 * sync with what the consumers query for (e.g. the inventory item picker
 * fetches `?appliesTo=SKU`).
 */
export const TagAppliesTo = {
    INVOICE: 'INVOICE',
    SKU: 'SKU',
} as const;

export type TagAppliesToType = typeof TagAppliesTo[keyof typeof TagAppliesTo];

/** Options rendered by the tag form's "Applies To" picker. */
export const TAG_APPLIES_TO_OPTIONS: { value: TagAppliesToType; label: string }[] = [
    { value: TagAppliesTo.INVOICE, label: 'Invoice' },
    { value: TagAppliesTo.SKU, label: 'Item (SKU)' },
];

export const TAG_STATUS_OPTIONS = ['active', 'inactive'];

/**
 * Interface for a tag master record.
 */
export interface ITag {
    _id: string;
    account?: string;
    name: string;
    slug?: string;
    description?: string;
    color?: string;
    appliesTo?: string[];
    status: string;
    createdAt?: string;
    updatedAt?: string;
}

/**
 * Interface for tag form inputs.
 */
export interface ITagFormInputs {
    name: string;
    description?: string;
    color?: string;
    appliesTo?: string[];
    status?: string;
}

/**
 * Interface for the update tag thunk payload.
 */
export interface ITagUpdatePayload {
    id: string;
    tagPayload: ITagFormInputs;
}

/**
 * Response from the delete endpoint. Delete is a soft delete, so the retired
 * tag comes back with `status: "inactive"` rather than disappearing.
 */
export interface ITagDeleteResponse {
    tag: ITag;
    message: string;
}

/**
 * Interface for tag slice state.
 */
export interface ITagSliceState {
    tags: ITag[];
    tagDetails?: ITag;
    errorMessage?: string | null;
    status: ApiStatus;
}
